(function () {
  if (window.ncCartUpsellReady) return;
  window.ncCartUpsellReady = true;

  function getSections() {
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
    );
    return sections;
  }

  function addUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart/add.js';
  }

  document.addEventListener('change', function (event) {
    var field = event.target.closest('[data-nc-variant]');
    if (!field) return;
    var msg = field.closest('[data-nc-upsell-item]').querySelector('[data-nc-msg]');
    if (msg) msg.textContent = '';
  });

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-nc-upsell-add]');
    if (!btn) return;
    event.preventDefault();

    var item = btn.closest('[data-nc-upsell-item]');
    var wrap = btn.closest('[data-nc-upsell]');
    var field = item.querySelector('[data-nc-variant]');
    var msg = item.querySelector('[data-nc-msg]');
    var id = field ? field.value : '';

    if (!id) {
      msg.textContent = item.getAttribute('data-choose') || 'Elige primero tu talla';
      if (field && field.focus) field.focus();
      return;
    }

    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Añadiendo…';

    fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: Number(id), quantity: 1, sections: getSections(), sections_url: window.location.pathname })
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        if (!r.ok || r.data.status) throw new Error(r.data.description || 'error');
        msg.textContent = (wrap && wrap.getAttribute('data-added')) || 'Añadido a tu cesta';
        if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents && r.data.sections) {
          window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart: r.data });
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        }
      })
      .catch(function () {
        msg.textContent = 'No hemos podido añadirlo. Inténtalo de nuevo, por favor.';
        btn.disabled = false;
        btn.textContent = label;
      });
  });
})();
